module.exports = __webpack_public_path__ + "img/66500budui1.d8f50e76.jpg";